import { useCallback } from "react";
import { isConfigurationValueNumeric, memoize, } from "@plansoft-configuration-renderer/utils";
// FIXME: format properly
const getNumberFormatter = memoize((locale) => new Intl.NumberFormat(locale, { maximumFractionDigits: 17 }));
/**
 * Format a value according to its type
 * @private Work in progress
 * @param options
 * @returns
 */
export function useConfigurationValueFormatter(options) {
    const localeCode = options.localeCode;
    return useCallback((attribute, value) => {
        var _a, _b;
        // if numeric, format
        if (isConfigurationValueNumeric(attribute, value)) {
            return getNumberFormatter(localeCode).format(value.value);
        }
        // edge case, this might happen for editable attributes with values for the 0th value
        if (value.value == null) {
            return "";
        }
        // attribute is now a string or a boolean
        const valueAsString = (_a = value.value) === null || _a === void 0 ? void 0 : _a.toString();
        // if language dependent, translate
        if (attribute.isLanguageDependent) {
            return (_b = value.name) !== null && _b !== void 0 ? _b : valueAsString;
        }
        // else keep value as string
        return valueAsString;
    }, [localeCode]);
}
//# sourceMappingURL=useConfigurationValueFormatter.js.map